import React, { forwardRef, ReactNode } from 'react';
import InfoIcon from '~/icons/Info';
import {
  CloseButton,
  Title,
  BodyContentWrapper,
  TitleContentWrapper,
  ContentWrapper
} from './Content.styles';
import { CloseIcon } from '../../icons';
import { ArrowDirection, Direction } from '../../types';

export const displayConfiguration = {
  width: 250,
  arrowOffsetX: 0,
  arrowOffsetY: 0,
  contentOffsetX: 0,
  contentOffsetY: 0
};

export type DisplayConfiguration = typeof displayConfiguration;

export type ContentProps = DisplayConfiguration & {
  classNames?: {
    tooltip?: string;
  };
  persist: boolean;
  direction: Direction;
  hoverCallback: (e: React.MouseEvent) => void;
  showArrow: boolean;
  showIcon: boolean;
  closeCallback: (e: MouseEvent | TouchEvent) => void;
  top?: number;
  left?: number;
  title: ReactNode;
  content?: ReactNode;
};

const Content = forwardRef<HTMLElement, ContentProps>(
  (
    {
      classNames,
      title,
      content,
      hoverCallback,
      persist = false,
      direction,
      showArrow,
      showIcon,
      closeCallback,
      width = 250,
      ...rest
    },
    ref
  ) => {
    const arrowDirection = `${direction.split('-')[0]}-arrow` as ArrowDirection;
    const directionStartOrEnd = direction.split('-')[1]
      ? direction.split('-')[1]
      : '';
    const canMoveArrowLeftOrRight =
      arrowDirection === 'top-arrow' || arrowDirection === 'bottom-arrow';

    return (
      <ContentWrapper
        role="tooltip"
        className={classNames?.tooltip}
        showArrow={showArrow}
        top={rest.top}
        left={rest.left}
        width={width}
        canMoveArrowLeftOrRight={canMoveArrowLeftOrRight}
        arrowDirection={arrowDirection}
        directionStartOrEnd={directionStartOrEnd}
        ref={ref as React.Ref<HTMLDivElement>}
        onMouseEnter={hoverCallback}
      >
        <TitleContentWrapper>
          {showIcon && <InfoIcon className="mr-4 text-text-inverse" />}
          {title && <Title>{title}</Title>}
          {persist && (
            <CloseButton
              data-analytics-id={null}
              data-testid="close-tooltip"
              aria-label="close"
              type="button"
              name="close"
              onClick={closeCallback as any}
            >
              <CloseIcon />
            </CloseButton>
          )}
        </TitleContentWrapper>
        {content && <BodyContentWrapper>{content}</BodyContentWrapper>}
      </ContentWrapper>
    );
  }
);

export default Content;
